<template>
  <layout-header>
    <router-view />
  </layout-header>
</template>

<script>
import LayoutHeader from '@core/layouts/layout-header/LayoutHeader.vue'

export default {
  components: {
    LayoutHeader,
  },
}
</script>
